module.exports = __webpack_public_path__ + "static/media/do-their-words-rub-out-there.4348f658.txt";